<template>
	<div class="menu">
		<div class="menu-pc">
			<div class="menu-left">
				<a href="/"><img src="../assets/img/logoBox.png" alt="" style="margin-top: 12px;" /></a>
				
			</div>
			<div class="menu-right">
				<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
					<el-menu-item index="1"><a href="/">首页</a></el-menu-item>
					<el-menu-item index="2"><router-link to="./Index">关于中亚</router-link></el-menu-item>
					<el-submenu index="3">
						<template slot="title">战略规划</template>
						<el-menu-item index="3-1"><router-link to="./twoSystem">两大体系</router-link></el-menu-item>
						<el-menu-item index="3-2"><router-link to="./fourFeature">四大功能</router-link></el-menu-item>
						<el-menu-item index="3-3"><router-link to="./eightPlate">八大板块</router-link></el-menu-item>
						<el-menu-item index="3-3"><router-link to="./developmentPlanning">发展规划</router-link></el-menu-item>
					</el-submenu>
					<el-menu-item index="4"><router-link to="./newsCenter">新闻中心</router-link></el-menu-item>
					<el-menu-item index="5"><router-link to="./socialResponsibility">社会责任</router-link></el-menu-item>
					<el-menu-item index="6"><router-link to="./aboutUs">联系我们</router-link></el-menu-item>
				</el-menu>
				<div class="tel">
					<div><img src="../assets/img/tel.png" alt="" /></div>400-0451-000
				</div>
			</div>
		</div>
		<div class='menu-mb'>
			<div class='menu-mb-left'>
				<a href="/"><img src="../assets/img/logoBox.png" alt="" style="margin-top: 12px;" /></a>
			</div>
			<div class='menu-mb-right'>
				<el-menu
				      :default-active="activeIndex"
				      class="el-menu-vertical-demo"
					  active-text-color='#0C4B36'
					  mode='vertical' :collapse="true"
				    >
				    <el-submenu index="1" >
				        <template slot="title" style="text-align: right;">
				          <span class="menu-box-span">
							  <img src="../assets/img/menuMb.png" alt="" />
						  </span>
				        </template>
				        <el-menu-item-group class="menu-mb-position" >
				         <el-menu-item index="/"><a href="/">首页</a></el-menu-item>
				         <el-menu-item index="Index"><router-link to="./Index">关于中亚</router-link></el-menu-item>
				         <el-submenu index="3" >
				         	<template slot="title" >战略规划 > </template>
				         	<el-menu-item  index="twoSystem"><router-link to="./twoSystem">两大体系</router-link></el-menu-item>
				         	<el-menu-item index="fourFeature"><router-link to="./fourFeature">四大功能</router-link></el-menu-item>
				         	<el-menu-item index="eightPlate"><router-link to="./eightPlate">八大板块</router-link></el-menu-item>
				         	<el-menu-item index="developmentPlanning"><router-link to="./developmentPlanning">发展规划</router-link></el-menu-item>
				         </el-submenu>
				         <el-menu-item index="newsCenter"><router-link to="./newsCenter">新闻中心</router-link></el-menu-item>
				         <el-menu-item index="socialResponsibility"><router-link to="./socialResponsibility">社会责任</router-link></el-menu-item>
				         <el-menu-item index="aboutUs"><router-link to="./aboutUs">联系我们</router-link></el-menu-item>
				        </el-menu-item-group>
					</el-submenu>
				</el-menu>
			</div>
			 
		</div>
	</div>
</template>

<script>
export default {
	name: 'menu',
    data() {
      return {
        activeIndex: '/',
		isCollapse: true
      };
    },
	mounted(){
		this.activeIndex=this.$route.name
	},
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      }
    }
  }
</script>
<style scoped>
@import '../assets/scss/commen.scss';
@import '../assets/scss/menu.scss';
.el-menu--horizontal >>>.el-menu--popup-bottom-start{
	    margin-left: 19px!important;
}
@media(max-width:768px){
	.menu-pc{
		display: none;
	}
	.menu-mb{
		display: flex;
		justify-content: space-between;
		margin: 0 5%;
	}
	.menu-mb-left{
		width:70%;
	}
	.menu-mb-right{
		width:70px;
	}
	.el-submenu .el-menu-item{
		padding: 0;
		text-align: left;
	}
	 .el-menu--collapse>.el-submenu>.el-submenu__title span{
		width: 30px;
		height: 50px;
		visibility: visible;
	 }
	.menu-box-span{
		display: inline-block;
		width: 30px;
		height: auto;
		float: right;
	}
	.el-submenu >>>.el-submenu__title{
		text-align: left;
		border: none;
	}
	.el-submenu >>>.el-submenu__title .el-submenu__icon-arrow{
		display: none;
	}
	.menu-mb-position{
		width: 100%;
		position: fixed;
		left: 0px;
		z-index: 9;
		background: #fff;
		top: 56px;
	}
	.menu-mb-right>.el-menu-vertical-demo{
		    width: 70px;
			border: none;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/menu.vue